import { Button, Css, ModalBody, ModalFooter, ModalHeader, Switch, useModal } from "@homebound/beam";
import { useState } from "react";
import { baseDownloadUrl } from "src/context";
import { ProjectFinishScheduleMetadataQuery } from "src/routes/projects/finish-schedule/ProjectFinishSchedulePage.generated";
import { openInSelf } from "src/utils/window";

type ExportProjectFinishScheduleModalProps = {
  project: ProjectFinishScheduleMetadataQuery["project"];
};

export function ExportProjectFinishScheduleModal(props: ExportProjectFinishScheduleModalProps) {
  const { project } = props;
  const { closeModal } = useModal();
  const [visualMode, setVisualMode] = useState(false);

  return (
    <>
      <ModalHeader>Export {project.name} Finish Schedule</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.my1.gap2.$}>
          <Switch compact label="Visual Mode" selected={visualMode} onChange={setVisualMode} />
        </div>
      </ModalBody>
      <ModalFooter>
        <div css={Css.df.gap2.$}>
          <Button variant="quaternary" label="Cancel" onClick={closeModal} />
          <Button
            variant="primary"
            label="Export"
            onClick={() => {
              openInSelf(
                `${baseDownloadUrl()}/${visualMode ? "pdf" : "xlsx"}?${buildQueryParams(visualMode, project.id)}`,
              );
              closeModal();
            }}
          />
        </div>
      </ModalFooter>
    </>
  );
}

function buildQueryParams(visualMode: boolean, projectId: string) {
  // build the query params for the PDF download url
  const params = new URLSearchParams({
    projectId,
    type: visualMode ? "projectFinishScheduleVisualMode" : "lfsFinishSchedule",
  });
  return params.toString();
}
